import React from "react";
import {profileImageUrl, ventureImageUrl} from "../../../helpers/urls";

const UserOptionLabel = (user) =>
    <span><img className="user__img" src={profileImageUrl(user)} /> {user.last_name}, {user.first_name}</span>;

export default UserOptionLabel;
